/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import { InfoPopover } from "components/InfoPopover"
import CashFlow from "features/userParameters/CashFlow"
import { UserParameters } from "features/userParameters/UserParametersSchema"
import { useFieldArray, useFormContext } from "react-hook-form"
import { toDisplayDate } from "utils/dateUtils"

const AllCashFlows = () => {
  const { control, register, getValues } = useFormContext<UserParameters>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: "cashFlows",
  })

  const retirementStartYearMonth = getValues("retirementStart")
  const retirementDate = toDisplayDate(retirementStartYearMonth) ?? new Date()

  return (
    <fieldset className="form-group mb-3 p-3 border rounded" id="cash-flows">
      <legend className="d-flex align-items-center">
        Cash Flows
        <InfoPopover
          htmlContent={true}
          content={`
            <p>Use positive numbers for inflows (e.g., pensions) and negative numbers for outflows (e.g., mortgage).</p>
            <p>For cash flows that will be adjusted by inflation (e.g. social security, public pension, etc.) use values in today's $. For others (corporate pension, mortgage etc.) use future $.</p>
          `}
        />
      </legend>
      <div id="cash-flow-container">
        {fields.map((field, index) => (
          <CashFlow key={field.id} index={index} register={register} remove={remove} />
        ))}
      </div>
      <button
        type="button"
        id="add-cash-flow-button"
        className="btn btn-secondary mt-3"
        onClick={() => {
          append({
            name: "",
            amount: 0,
            frequency: "monthly",
            inflationAdjusted: false,
            start: { year: retirementDate.getFullYear(), month: retirementDate.getMonth() + 1 },
            end: { year: retirementDate.getFullYear() + 1, month: retirementDate.getMonth() + 1 },
          })
        }}
      >
        Add Cash Flow
      </button>
    </fieldset>
  )
}

export default AllCashFlows
